export const formattedAmount = (num) =>
  parseFloat(num)
    .toFixed(1)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    .replace('.00', '');
export const formatDate = (date) => {
  let d = new Date(date);
  return `${d.getDate()}-${d.getMonth() + 1}`;
};

export const filterData = (
  data,
  selectedStatus,
  selectedRegion,
  searchTerm,
  selectedUnitSize,
  selectedStore
) => {
  if (!data) return [];

  let newData = [...data];

  newData = newData.filter((location) => {
    let filter = false;

    if (
      selectedRegion !== 'All Regions' &&
      !location.region.includes(selectedRegion)
    )
      filter = true;

    if (selectedStore !== 'All Stores' && location.name !== selectedStore)
      filter = true;

    if (
      searchTerm &&
      searchTerm.length &&
      !JSON.stringify(location).toLowerCase().includes(searchTerm.toLowerCase())
    )
      filter = true;

    return !filter;
  });

  newData = newData.map((location) => {
    let newLocation = { ...location };

    newLocation.units = location.units.filter((unit) => {
      if (selectedStatus !== 'all' && unit.status !== selectedStatus)
        return false;

      const range = selectedUnitSize.split('-').map(Number);
      if (
        selectedUnitSize !== 'All Sizes' &&
        (unit.unitSize < range[0] || unit.unitSize > range[1])
      )
        return false;

      if (
        searchTerm &&
        searchTerm.length &&
        !JSON.stringify(unit).toLowerCase().includes(searchTerm.toLowerCase())
      )
        return false;

      return true;
    });
    return newLocation;
  });

  return newData.filter((location) => location.units.length > 0);
};

export const calculateStats = (data) => {
  const allUnits = data?.flatMap((loc) => loc.units) || data?.units || [];

  if (!allUnits.length)
    return {
      eligibleRentals: { value: 0, valueDesc: 0, percent: '0' },
      proposedRentIncrease: { value: 0, valueDesc: '0', percent: '0' },
      approvedIncreases: { value: 0, valueDesc: 0, percent: '0' },
      finalRentIncrease: { value: 0, valueDesc: '0', percent: '0' },
    };

  // Calculation for box1...
  const eligibleUnits = allUnits;
  const eligibleRentals = eligibleUnits.length;

  let totalProposedIncrease = 0;
  let totalCurrentRentEligible = 0;

  for (let i = 0; i < eligibleUnits.length; i++) {
    const u = eligibleUnits[i];
    const currentPrice = parseFloat(u.currentPrice || 0);
    const suggestedPrice = parseFloat(u.suggestedPrice || 0);

    if (currentPrice > 0) {
      totalProposedIncrease += suggestedPrice - currentPrice;
      totalCurrentRentEligible += currentPrice;
    }
  }

  const totalProposedIncreasePercent =
    totalCurrentRentEligible > 0
      ? (totalProposedIncrease / totalCurrentRentEligible) * 100
      : 0;

  // Calculation for box2...
  const approvedUnits = allUnits.filter((u) => u.status === 'approved');
  const approvedIncreases = approvedUnits.length;

  let totalFinalIncrease = 0;
  let totalCurrentRentApproved = 0;

  for (let u of approvedUnits) {
    const currentPrice = parseFloat(u.currentPrice || 0);
    const finalPrice = parseFloat(u.finalPrice || 0);

    if (currentPrice > 0) {
      totalFinalIncrease += finalPrice - currentPrice;
      totalCurrentRentApproved += currentPrice;
    }
  }

  const totalFinalIncreasePercent =
    totalCurrentRentApproved > 0
      ? (totalFinalIncrease / totalCurrentRentApproved) * 100
      : 0;

  return {
    eligibleRentals: { value: eligibleRentals, valueDesc: eligibleRentals },
    proposedRentIncrease: {
      value: Math.round(totalProposedIncrease),
      valueDesc: Math.round(totalProposedIncrease),
      percent: totalProposedIncreasePercent.toFixed(2),
    },
    approvedIncreases: {
      value: approvedIncreases,
      valueDesc: approvedIncreases,
    },
    finalRentIncrease: {
      value: Math.round(totalFinalIncrease),
      valueDesc: Math.round(totalFinalIncrease),
      percent: totalFinalIncreasePercent.toFixed(2),
    },
  };
};
